import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { IconReactionPositiveSmall } from '@sololearnorg/sol';
import { Container, i18n } from '../../../../symphony';

import { SlCodeBitsContext } from '../../global-constants';
import { ActionType, RequestType } from '../../global-interface';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { SlDataService } from '../../services/sl-data.service';
import { useComponentWillMount } from '../../../../shared/public/SlUtils/useComponentWillMount';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { LocalizedLink } from '../../../../shared/public/LocalizedLink/LocalizedLink';

import s from './HotToday.scss';

export function HotToday() {
	useStyles(s);
	const { actions$ } = Container.take(SlCodeBitsContext, SlActions);

	useComponentWillMount(() => {
		actions$.next({
			type: ActionType.OnHotTodayMount,
			requestType: RequestType.Parallel,
		});
	});

	const { hotTodayProjects$: hotTodayProjects } = useContainerData(
		SlCodeBitsContext,
		SlDataService,
		['hotTodayProjects$'],
	);

	const onTopicClick = (codeId: string) => {
		actions$.next({
			type: ActionType.OnTopicClick,
			requestType: RequestType.Parallel,
			data: {
				codeId,
			},
		});
	};

	return (
		<div className="sl-code-bits-hot-today">
			<div className="sl-code-bits-hot-today__title">
				{i18n.t('web-code.hot-today-title')}
			</div>
			{hotTodayProjects?.map((project) => (
				<div className="sl-code-bits-hot-today__topic" key={project.id}>
					<LocalizedLink
						to={`/compiler-playground/${project.publicId}`}
						target="_blank"
						className="sl-code-bits-hot-today__topic__title"
						onClick={() => onTopicClick(project.publicId)}
					>
						{project.name}
					</LocalizedLink>
					<div className="sl-code-bits-hot-today__topic__votes">
						<IconReactionPositiveSmall />
						{' '}
						{i18n.t('web-code.hot-today-votes-count', {
							count: project.votes,
						})}
					</div>
				</div>
			))}
		</div>
	);
}
